import React from "react";
import CruiseWizardPage from "@/pages/Cruise/CruiseWizardPage";
import {Button, ButtonType, Form, TextAreaInput} from "@reapptor-apps/reapptor-react-components";
import CruiseConstants from "@/helpers/CruiseConstants";
import Localizer from "@/localization/Localizer";

import styles from "./Comments.module.scss";

export interface ICommentsProps {
}

interface ICommentsState {
}

export default class Comments extends CruiseWizardPage<ICommentsProps, ICommentsState> {

    state: ICommentsState = {
    };

    private readonly _formRef: React.RefObject<Form> = React.createRef();

    public async setCommentAsync(value: string): Promise<void> {
        this.wizard.comment = value;
        this.saveContext();
    }

    public async nextAsync(): Promise<void> {
        if (this._formRef.current) {
            const isValid: boolean = await this._formRef.current.validateAsync();
            if (isValid) {
                this.saveContext();
                await super.nextAsync();
            }
        }
    }

    public get canNext(): boolean {
        return (this.wizard.groupSizeValue > 0) && (this.wizard.groupSizeValue <= 999);
    }
    
    public get commentPlaceholder(): string {
        return (this.isFishing)
            ? Localizer.cruiseWizardFishingCruiseNeeds
            : (this.isHovercraft)
                ? ""
                : Localizer.cruiseWizardLengthOfCruise;                
    }
    

    public renderButtons(): React.ReactNode {
        return (
            <React.Fragment>
                <Button block type={ButtonType.Dark} label={Localizer.cruiseWizardNext} onClick={() => this.nextAsync()} />

                <Button block type={ButtonType.Light} label={Localizer.cruiseWizardBack} onClick={() => this.prevAsync()} />
            </React.Fragment>
        )
    }

    public renderContent(): React.ReactNode {
        return (
            <Form ref={this._formRef} className={styles.comments}>

                <p>{Localizer.cruiseWizardSomethingToKnow}</p>

                <TextAreaInput placeholder={this.commentPlaceholder}
                               className={styles.item}
                               maxLength={CruiseConstants.descriptionLength}
                               value={this.wizard.comment}
                               onChange={(sender, value) => this.setCommentAsync(value)}
                />

            </Form>
        );
    }
}